import { render, staticRenderFns } from "./myPage.vue?vue&type=template&id=c5f9a4ca&"
import script from "./myPage.vue?vue&type=script&lang=ts&"
export * from "./myPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports